module.exports = __webpack_public_path__ + "961a020aa6333a448ce289519ef41155.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/rafail.jpg
// module id = 44
// module chunks = 0